import {DisposalSet, select} from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';

import './styles.scss';

const gc = new DisposalSet();

registerFragment('chroa-betty-bot', (fragmentEl, config, meta) => {
    // *This is from the demo implementation, but changed very slightly to remove errors
    // *This is core logic required for the fragment to work, I don't recommend messing with it...
    function getQueryStringParameters() {
        var params: Record<string, string> = {};
        var queryString: string = window.location.search.substring(1);
        var vars: string[] = queryString.split('&');
        for (var i: number = 0; i < vars.length; i++) {
            var pair: string[] = vars[i].split('=');
            params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
        return params;
    }

    window.onload = function(): void {
        var queryParams = getQueryStringParameters();
        var bettyBotElement = document.querySelector('.demo-betty') as Element;
        if (queryParams.userid) {
            bettyBotElement.setAttribute('user-id', queryParams.userid);
        }
    }

    /*
        --- * Auto Query from Widget * ---
    */

    // *Widget Query Logic
    const widgetQuery = sessionStorage.getItem("bettyBotQuery");

    if (widgetQuery) {
        let attempts = 0;
        const MAX_ATTEMPTS = 50;

        const trySubmit = setInterval(() => {
            attempts++;

            const textArea = fragmentEl.querySelector("#input") as HTMLTextAreaElement;
            const submitBtn = fragmentEl.querySelector("#btnSend") as HTMLButtonElement;

            if (textArea && submitBtn) {
                clearInterval(trySubmit);

                setTimeout(() => {
                    textArea.value = widgetQuery;
                    // *These events are required for BettyBot's textarea field to work
                    textArea.dispatchEvent(new Event('input', { bubbles: true }))
                    textArea.dispatchEvent(new Event('change', { bubbles: true }))

                    sessionStorage.removeItem('bettyBotQuery');

                    const fakeMousedown = new MouseEvent('mousedown', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    })

                    const fakeMouseup = new MouseEvent('mouseup', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    })
                    // *These events are required for BettyBot's button field to work
                    submitBtn.dispatchEvent(fakeMousedown);
                    submitBtn.dispatchEvent(fakeMouseup);
                    submitBtn.click();
                }, 100);
            } else if (attempts >= MAX_ATTEMPTS) {
                clearInterval(trySubmit);
                console.warn("BettyBot: Could not load Betty-Bot interface to search.");
            }
        }, 100);
    }
});

if (import.meta.hot) {
    import.meta.hot.accept();
    import.meta.hot.dispose(() => gc.disposeAll());
}
